<div class="padding-md wrap">
  <div *ngIf="order.items as orderItems" class="scrollable">
    <div class="message">
      <div class="icon">
        <img src="assets/icon/success-mark.svg" alt="success" />
      </div>
      <pre class="text">
        {{ "@components.orderConfirmation.success" | translate }}
      </pre>
    </div>

    <ng-container *ngIf="order.type === ORDER_TYPES.DELIVERY">
      <div class="product-list">
        <div *ngFor="let weekIndex of weeksInOrder$ | async" class="by-weeks">
          <div class="week-header-container">
            <div class="week-header">
              {{ "@common.weeksByIndex." + weekIndex | translate }}
            </div>
            <div class="range">
              {{ cartService.getWeekSlotAsString(weekIndex) }}
            </div>
          </div>

          <div
            class="by-days"
            *ngFor="
              let day of cartService.getDeliveryDaysOfWeek$(
                (weekIndex | weekNumberByWeekIndex)!
              ) | async
            "
          >
            <div class="header">
              <div class="day-name">
                {{ "@common.days.full." + day | translate }}
              </div>
              <div class="timeslot">
                {{ order.location.workTime }}
              </div>
            </div>
            <div
              class="order-item-list"
              *ngFor="
                let orderItem of order.items
                  | filterOrderItemsByDay : day : weekIndex
                  | async
              "
            >
              <app-order-item
                [label]="orderItem.item.name"
                [amount]="orderItem.quantity"
                [price]="orderItem.item | getRelevantProductPrice | getPrimaryCurrencyPrice"
              ></app-order-item>
            </div>
          </div>
        </div>
        <div
          *ngIf="(weeksInOrder$ | async) === null"
          class="app-spinner-container"
        >
          <ion-spinner class="app-spinner"></ion-spinner>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="order.type === ORDER_TYPES.IN_STORE">
      <app-order-item
        *ngFor="let orderItem of orderItems"
        [label]="orderItem.item.name"
        [amount]="orderItem.quantity"
        [price]="orderItem.item | getRelevantProductPrice | getPrimaryCurrencyPrice"
      ></app-order-item>
    </ng-container>

    <div class="info-block delivery-to">
      <div class="header">
        {{ "@pages.orderSummary.deliveryTo.header" | translate }}
      </div>
      <div class="text">
        {{ order.location.name }}, {{ order.location.address }}
      </div>
    </div>

    <hr class="" />

    <div class="prices">
      <div class="item">
        <div class="label total">
          {{ "@pages.orderSummary.prices.total" | translate }}
        </div>
        <app-price-label
          [value]="order.prices | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div>
    </div>
  </div>
  <div class="footer">
    <app-action-button
      (click)="onGoBackToDashboard()"
      [isOutlined]="true"
      [label]="'@components.orderConfirmation.actionBtn' | translate"
    ></app-action-button>
  </div>
</div>
